import { InputBaseComponentProps } from '@material-ui/core'

export enum DateFormats {
  Time = 'HH:mm',
  Date = 'dd/MM/yyyy'
}

export enum InputTypes {
  Text = 'text',
  Number = 'number',
  Select = 'select',
  Email = 'email',
  Checkbox = 'checkbox',
  Date = 'Date',
  Tel = 'Tel'
}

export enum LabelPlacement {
  Bottom = 'bottom',
  End = 'end',
  Start = 'start',
  Top = 'top'
}

export enum FieldTypes {
  Textfield = 'textfield',
  Select = 'select',
  Radio = 'radio',
  Checkbox = 'checkbox',
  Date = 'date',
  Time = 'time',
  RadioGroup = 'radio-group',
  FormGroup = 'form-group',
  FormControl = 'form-control'
}

export enum FormSectionTypes {
  Card = 'card',
  FormControl = 'form-control',
  MultiCard = 'multi-card'
}

export enum IconTypes {
  Delete = 'Delete',
  Add = 'Add',
  Done = 'Done',
  ArrowForward = 'ArrowForward',
  ArrowBack = 'ArrowBack',
  Play = 'Play',
  CircularProgress = 'CircularProgress'
}

export interface GetTokenAPIResponse {
  sid: string
  token: string
}

export interface ErrorMessages {
  required: string
}

export interface FormCondition {
  [key: string]: any
}

export interface FormSection {
  type: FormSectionTypes
  inputType?: string
  key: string
  showWhenMet?: FormCondition[]
  label?: string
  helperText?: string
  fullWidth?: boolean
  direction?: 'row' | 'column'
  required?: boolean
  actions?: DynamicCardAction[]
  fields: (
    | DynamicCheckboxOption
    | DynamicFormGroup
    | DynamicRadioGroup
    | DynamicTextField
    | DynamicDateField
    | FormSection
  )[]
  errorMessages?: ErrorMessages
}

export interface DynamicSelectOption {
  key: string
  label: string
  value: string
}

export interface DynamicRadioGroup {
  type: FieldTypes.RadioGroup
  label?: string
  key: string
  showWhenMet?: FormCondition[]
  fullWidth?: boolean
  value?: string
  format?: string
  horizontal?: boolean
  fields: DynamicRadioOption[]
  errorMessages?: ErrorMessages
}

export interface DynamicFormGroup {
  type: FieldTypes.FormGroup
  key: string
  showWhenMet?: FormCondition[]
  value?: string
  format?: string
  fullWidth?: boolean
  horizontal?: boolean
  fields: DynamicRadioOption[]
}

export interface DynamicTextField {
  type: string
  inputType?: string
  required?: boolean
  horizontal?: boolean
  placeholder?: string
  key: string
  label?: string
  value?: string
  format?: string
  multiline?: boolean
  helperText?: string
  fullWidth?: boolean
  inputProps?: InputBaseComponentProps
  errorMessages?: ErrorMessages
  selectOptions?: DynamicSelectOption[]
  showWhenMet?: FormCondition[]
  selected?: boolean
  autoComplete?: string
  fields?: (
    | DynamicCheckboxOption
    | DynamicFormGroup
    | DynamicRadioGroup
    | DynamicTextField
    | DynamicDateField
    | FormSection
  )[]
}

export interface DynamicRadioOption {
  type: string
  label: string
  value?: string
  format?: string
  selected?: boolean
  fullWidth?: boolean
  labelPlacement?: LabelPlacement
  key: string
  autoComplete?: string
}

export interface DynamicCheckboxOption {
  type: string
  inputType?: string
  label: string
  value?: string
  format?: string
  labelPlacement?: LabelPlacement
  key: string
  showWhenMet?: FormCondition[]
  selected?: boolean
  required?: boolean
  placeholder?: string
  multiline?: boolean
  helperText?: string
  fullWidth?: boolean
  inputProps?: InputBaseComponentProps
  errorMessages?: ErrorMessages
  selectOptions?: DynamicSelectOption[]
  autoComplete?: string
  fields?: (
    | DynamicCheckboxOption
    | DynamicFormGroup
    | DynamicRadioGroup
    | DynamicTextField
    | DynamicDateField
    | FormSection
  )[]
}

export interface DynamicDateField {
  type: string
  inputType?: string
  required?: boolean
  key: string
  value?: string
  format?: string
  label: string
  helperText?: string
  fullWidth?: boolean
  inputProps?: InputBaseComponentProps
  showWhenMet?: FormCondition[]
  selected?: boolean
  autoComplete?: string
  fields?: (
    | DynamicCheckboxOption
    | DynamicFormGroup
    | DynamicRadioGroup
    | DynamicTextField
    | DynamicDateField
    | FormSection
  )[]
}

export interface DynamicCardAction {
  size: 'large' | 'medium' | 'small'
  color: 'default' | 'inherit' | 'primary' | 'secondary'
  variant: 'contained' | 'outlined' | 'text'
  startIcon: IconTypes
  endIcon: IconTypes
  label: string
  utterance: string
  submitFieldAsUtterance: string
}

export default interface Form {
  title: string
  layout: FormSection[]
}
